/* COVA media gallery: product cards appear on a timer (one tile after another) and on hover; videos play on tap */
(function () {
  'use strict';
  function ready(fn) { if (window.CV && window.CV.register) fn(); else window.addEventListener('load', fn); }
  ready(function () {
    CV.register('[data-cv-mg]', function (root) {
      var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-cv-mg-tile]'));
      var delay = (parseFloat(root.getAttribute('data-delay')) || 3) * 1000;
      var hold = (parseFloat(root.getAttribute('data-hold')) || 10) * 1000;
      var mq = window.matchMedia('(min-width: 768px)');
      var timers = [];
      function clear() { timers.forEach(clearTimeout); timers = []; tiles.forEach(function (t) { t.classList.remove('is-shown'); }); }
      function run() {
        clear();
        if (!mq.matches || !tiles.length) return;
        tiles.forEach(function (t, i) {
          timers.push(setTimeout(function () { t.classList.add('is-shown'); }, delay + i * 600));
          timers.push(setTimeout(function () { t.classList.remove('is-shown'); }, delay + i * 600 + hold));
        });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { if (en[0].isIntersecting) run(); else clear(); }, { threshold: 0.3 }).observe(root);
      }
      mq.addEventListener && mq.addEventListener('change', run);
      root.querySelectorAll('[data-cv-mg-play]').forEach(function (btn) {
        var video = btn.parentElement.querySelector('video');
        btn.addEventListener('click', function () {
          if (!video) return;
          if (video.paused) { video.play(); btn.setAttribute('aria-label', 'Pause'); } else { video.pause(); btn.setAttribute('aria-label', 'Play'); }
        });
      });
    });
  });
})();
